import type { EntityTypes } from 'api/data.types'

type TabConfig = {
  value: EntityTypes
  label: string
}

const getEducatorTabs = (t: (key: string) => string): TabConfig[] => [
  { value: 'trademark', label: t('Gestores Regionais') },
  { value: 'network', label: t('Gestores Municipais') },
  { value: 'school', label: t('Gestores de Unidade') },
  { value: 'class', label: t('Professores') }
]

type CurrentEntitiesIdSelecteds = {
  holdingId?: number | null
  trademarkId?: number | null
  networkId?: number | null
  schoolId?: number | null
  classId?: number | null
}

export const getAvailableEducatorTabs = (
  userEntityType: EntityTypes | undefined,
  currentEntityTypeSelected: EntityTypes | undefined,
  t: (key: string) => string,
  currentEntitiesIdSelecteds?: CurrentEntitiesIdSelecteds
): TabConfig[] => {
  if (userEntityType === 'class') {
    return []
  }

  const entityHierarchy: Record<EntityTypes, EntityTypes[]> = {
    holding: ['trademark', 'network', 'school', 'class'],
    trademark: ['network', 'school', 'class'],
    network: ['school', 'class'],
    school: ['class'],
    class: []
  }

  const availableEntityTypes = entityHierarchy[userEntityType || 'class'] || []

  let availableTabs = getEducatorTabs(t).filter(tab =>
    availableEntityTypes.includes(tab.value)
  )

  if (currentEntityTypeSelected) {
    const entityOrder: EntityTypes[] = [
      'trademark',
      'network',
      'school',
      'class'
    ]
    const currentIndex = entityOrder.indexOf(currentEntityTypeSelected)

    if (currentIndex !== -1) {
      const allowedFromCurrentLevel = entityOrder.slice(currentIndex)
      availableTabs = availableTabs.filter(tab =>
        allowedFromCurrentLevel.includes(tab.value)
      )
    }
  }

  if (currentEntitiesIdSelecteds) {
    const { trademarkId, networkId, schoolId } = currentEntitiesIdSelecteds

    if (schoolId) {
      availableTabs = availableTabs.filter(tab => tab.value === 'class')
    } else if (networkId) {
      availableTabs = availableTabs.filter(tab =>
        ['school', 'class'].includes(tab.value)
      )
    } else if (trademarkId) {
      availableTabs = availableTabs.filter(tab =>
        ['network', 'school', 'class'].includes(tab.value)
      )
    }
  }

  return availableTabs
}

export const canAccessEducatorReports = (
  userEntityType: EntityTypes | undefined,
  hasTeacherId?: boolean
): boolean => {
  if (!userEntityType) return false
  return userEntityType !== 'class' && !!hasTeacherId
}
